/* eslint-disable operator-linebreak */
/* eslint-disable arrow-parens */
import Slider from 'javascripts/globals/slider';
import { BREAKPOINTS } from 'javascripts/constants';

const mql = [window.matchMedia(`(min-width: ${BREAKPOINTS.l})`)];

let componentStore = [];

function onMediaQueryChange() {
  componentStore.forEach(
    component => component.deconstructor && component.deconstructor(),
  );
  componentStore = [];
  const isL = mql[0].matches;

  document.querySelectorAll('.columns').forEach($slider => {
    const $items = $slider.querySelectorAll('.columns__item');
    let disableSlider = true;
    const itemsLength = $items.length;
    let columns;
    const isDesktopSlider = $slider.classList.contains(
      'columns--slide-desktop',
    );
    const isMobileSlider = $slider.classList.contains('columns--slide-mobile');

    if ($slider.classList.contains('columns--1')) {
      columns = 1;
    } else if ($slider.classList.contains('columns--2')) {
      columns = 2;
    } else if ($slider.classList.contains('columns--3')) {
      columns = 3;
    } else if ($slider.classList.contains('columns--4')) {
      columns = 4;
    } else {
      // eslint-disable-next-line no-console
      console.error('column count not specified');

      return;
    }

    if (isMobileSlider && !isL && itemsLength > 1) {
      disableSlider = false;
    }

    if (isDesktopSlider && isL && itemsLength > columns) {
      disableSlider = false;
    }

    if (disableSlider) {
      return;
    }

    componentStore.push(
      new Slider($slider, {
        rewind: true,
        sliderFrame: 'columns__block',
        slidesContainer: 'columns__items',
        sliderSlide: 'columns__item',
        sliderControlsframe: 'columns__controls',
        sliderControlsframemethod: 'append',
        slidesToScroll: 1,
        slidesFocusable: false,
      }),
    );
  });
}

mql.forEach(el => {
  el.addListener(onMediaQueryChange);
});

onMediaQueryChange();
